import * as Sentry from '@sentry/react'
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { ContainerLayout } from '@/components/layouts'
import { getDefaultDcId } from '@/features/auth/models'
import { loginPath } from '@/libs/auth'
import { setSentryDcId, setSentryTenantKey } from '@/libs/sentry/sentry-config'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

export const Route = createFileRoute('/_protected')({
  component: ProtectedRouteLayout,
  beforeLoad: async ({ context }) => {
    // Sentryに送付するときのユーザー情報
    if (!context.auth.isAuthenticated) {
      Sentry.setUser(null)
      // テナントが確定しない画面ではタグも外す (#5134)
      setSentryTenantKey(null)
      setSentryDcId(null)
      throw redirect({
        to: loginPath,
        search: {
          redirect: location.href
        }
      })
    }
    const user = context.auth.user
    Sentry.setUser({
      id: user.id,
      username: user.displayName
    })

    // 拠点未選択(初回ログイン直後など)の場合、me が返すデフォルト拠点を初期選択する。
    // テナント内 API は X-DC-Id 必須のため、最初のテナント内リクエスト前にここで確定させる。
    if (tenantStore.get(selectedDcIdAtom) === 0) {
      const dcId = getDefaultDcId(user)
      if (dcId) {
        tenantStore.set(selectedDcIdAtom, dcId)
      }
    }
  }
})

function ProtectedRouteLayout() {
  return (
    <ContainerLayout
      data-testid="protected-route-layout"
      className="bg-white"
      hasSider
    >
      <Outlet />
    </ContainerLayout>
  )
}
